import * as TK from 'components/common/TextEditor/components/Toolbar/translations/constants';
import { Translations } from 'translations/types';

export const toolbarEnUsLocale: Translations = {
  [TK.TOOLBAR_OPEN_BUTTON_LABEL]: 'Aa',
};
